import { ExpandableQRCode } from "features/data-management/workspace/TODO-put-in-package/ExpandableQRCode"
import { singleStreamUrl } from "features/multi-stream/ShareLiveStreamModal"

export const LiveVideoQRCode = ({ flightId }: { flightId: string }) => {
    return (
        <div className="flex gap-2">
            <ExpandableQRCode
                title="Live Stream"
                value={singleStreamUrl({ flightId })}
                bgColor="transparent"
                fgColor="white"
                size={60}
                className="flex-shrink-0"
            />
            <div className="text-gray-300" style={{ maxWidth: "14rem" }}>
                Scan the QR code on your phone to watch the Live Stream
            </div>
        </div>
    )
}
